import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70faad6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-18" }, " Detalhamento da Baixa ", -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_4 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"right"} }, "Baixa Estornada", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-badge-status-dot ss-span-status estornada" }, null, -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estornar Baixa", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"10px","margin-bottom":"10px"}
}, null, -1))
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_26 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_27 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_28 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_29 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_30 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_31 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_32 = ["title"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = {
  key: 4,
  class: "acoes-item"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 5,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Juros/Multa:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Acréscimo:", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Desconto:", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Pago:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Taxas:", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_50 = { class: "acoes-item" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_53 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-12" }, null, -1))
const _hoisted_56 = ["title"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 2 }
const _hoisted_59 = { key: 3 }
const _hoisted_60 = {
  key: 4,
  class: "acoes-item"
}
const _hoisted_61 = ["onClick"]
const _hoisted_62 = {
  key: 5,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_68 = { class: "acoes-item" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 2 }
const _hoisted_73 = { key: 3 }
const _hoisted_74 = { key: 4 }
const _hoisted_75 = { key: 5 }
const _hoisted_76 = { key: 6 }
const _hoisted_77 = {
  key: 7,
  class: "acoes-item"
}
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  key: 8,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data:", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo Movimento:", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Identificador:", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria:", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Influência Saldo:", -1))
const _hoisted_87 = { class: "acoes-item" }
const _hoisted_88 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_titulo_financeiro = _resolveComponent("selecionar-tipo-titulo-financeiro")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_tipo_valor_financeiro = _resolveComponent("selecionar-tipo-valor-financeiro")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_card = _resolveComponent("card")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_conta_receber_modal = _resolveComponent("conta-receber-modal")!
  const _component_conta_pagar_modal = _resolveComponent("conta-pagar-modal")!
  const _component_movimento_financeiro_modal = _resolveComponent("movimento-financeiro-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    centered: "",
    width: "98%",
    "wrap-class-name": "full-modal ss-modal-financeiro",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event))
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_ctx.state.baixa.estornada)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (!_ctx.state.baixa.estornada && _ctx.state.exibirEstorno)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmarBaixa()))
          }, _hoisted_9))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_a_form_item, {
                        label: "Usuário",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_usuario, {
                            empresas: [_ctx.props.empresa],
                            codigoSelecionado: _ctx.state.baixa.codigoUsuario,
                            disabled: true
                          }, null, 8, ["empresas", "codigoSelecionado"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Baixa",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_titulo_financeiro, {
                            valor: _ctx.state.baixa.tipoTituloFinanceiro,
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_a_form_item, {
                        label: "Data",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            dataSelecionada: _ctx.state.baixa.dataBaixa,
                            disabled: true
                          }, null, 8, ["dataSelecionada"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_a_form_item, {
                        label: "Acréscimo Geral",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_valor_financeiro, {
                            valor: _ctx.state.baixa.tipoAcrescimo,
                            "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.baixa.tipoAcrescimo) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_a_form_item, {
                        label: " ",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: _ctx.state.baixa.tipoAcrescimo === 2,
                            percentual: _ctx.state.baixa.tipoAcrescimo === 1,
                            valor: _ctx.state.baixa.acrescimo,
                            "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.baixa.acrescimo) = $event)),
                            disabled: true
                          }, null, 8, ["monetario", "percentual", "valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_a_form_item, {
                        label: "Desconto Geral",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_valor_financeiro, {
                            valor: _ctx.state.baixa.tipoDesconto,
                            "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.baixa.tipoDesconto) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_a_form_item, {
                        label: " ",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: _ctx.state.baixa.tipoDesconto === 2,
                            percentual: _ctx.state.baixa.tipoDesconto === 1,
                            valor: _ctx.state.baixa.descontoAdicional,
                            "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.baixa.descontoAdicional) = $event)),
                            disabled: true
                          }, null, 8, ["monetario", "percentual", "valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_form_item, {
                        label: "Percentual de Juros",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            percentual: true,
                            valor: _ctx.state.baixa.percentualJuros,
                            "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.baixa.percentualJuros) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_a_form_item, {
                        label: "Percentual de Multa",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            percentual: true,
                            valor: _ctx.state.baixa.percentualMulta,
                            "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.baixa.percentualMulta) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_a_form_item, {
                        label: "Percentual de Descontos",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            percentual: true,
                            valor: _ctx.state.baixa.percentualDesconto,
                            "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.baixa.percentualDesconto) = $event)),
                            disabled: true
                          }, null, 8, ["valor"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_totalizador, {
                        titulo: "QTD DE TÍTULOS",
                        valor: _ctx.state.baixa.qtdTitulos,
                        casasDecimais: 0
                      }, null, 8, ["valor"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_totalizador, {
                        titulo: "TOTAL DOS TÍTULOS",
                        monetario: true,
                        valor: _ctx.state.baixa.totalTitulos
                      }, null, 8, ["valor"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_totalizador, {
                        titulo: "JUROS/MULTA",
                        monetario: true,
                        valor: _ctx.state.baixa.totalJurosMulta
                      }, null, 8, ["valor"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_totalizador, {
                        titulo: "ACRÉSCIMOS",
                        monetario: true,
                        valor: _ctx.state.baixa.totalAcrescimos
                      }, null, 8, ["valor"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_totalizador, {
                        titulo: "DESCONTOS",
                        monetario: true,
                        valor: _ctx.state.baixa.totalDescontos
                      }, null, 8, ["valor"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_totalizador, {
                        titulo: "ABATIMENTOS",
                        monetario: true,
                        valor: _ctx.state.baixa.totalAbatimentos
                      }, null, 8, ["valor"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_totalizador, {
                        titulo: "TAXAS",
                        monetario: true,
                        valor: _ctx.state.baixa.totalTaxas
                      }, null, 8, ["valor"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_totalizador, {
                        titulo: "TOTAL DA BAIXA",
                        monetario: true,
                        valor: _ctx.state.baixa.totalBaixa
                      }, null, 8, ["valor"])
                    ])
                  ])
                ]),
                _: 1
              }),
              ((_ctx.state.baixa.totalCreditosUtilizados > 0))
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    message: 'Foram utilizados R$ ' + _ctx.UtilitarioMascara.mascararValor(_ctx.state.baixa.totalCreditosUtilizados) + ' de créditos nessa baixa.',
                    type: "warning",
                    "show-icon": ""
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              ((_ctx.state.baixa.totalTitulosRepassados > 0))
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 1,
                    message: 'Foram repassados R$ ' + _ctx.UtilitarioMascara.mascararValor(_ctx.state.baixa.totalCreditosUtilizados) + ' de outros títulos nessa baixa.',
                    type: "warning",
                    "show-icon": ""
                  }, null, 8, ["message"]))
                : _createCommentVNode("", true),
              _createVNode(_component_card, { titulo: "TÍTULOS BAIXADOS" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_spin, {
                    spinning: _ctx.state.carregandoTitulosBaixados
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                        "data-source": _ctx.state.titulosBaixados,
                        rowKey: "codigoTituloFinanceiro",
                        scroll: _ctx.storeSistema.state.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth), y: 500 },
                        size: "small",
                        pagination: false,
                        "row-selection": _ctx.state.estornoParcialDisponivel?{ selectedRowKeys: _ctx.state.codigosTitulosFinanceirosEstorno, onChange: _ctx.mudarSelecao }: null
                      }, {
                        bodyCell: _withCtx(({ column, record, text }) => [
                          (column.key === 'TipoDocumentoFinanceiro')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                title: record.descricaoTipoDocumentoFinanceiro
                              }, _toDisplayString(record.siglaTipoDocumentoFinanceiro), 9, _hoisted_32))
                            : (column.key === 'ValorPago')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.obterTotalPago(record),2)), 1))
                              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text,2)), 1))
                                  : (column.key === 'Acoes')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.visualizarTituloBaixado(record)),
                                          title: "Visualizar Título"
                                        }, [
                                          _createVNode(_component_icone, { nome: "visualizar" })
                                        ], 8, _hoisted_37),
                                        ((_ctx.state.estornoParcialDisponivel && _ctx.state.titulosBaixados.length > 1))
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 0,
                                              onClick: ($event: any) => (_ctx.confirmarEstornoTituloBaixa(record.numeroTitulo, record.codigoTituloFinanceiro)),
                                              title: "Estornar"
                                            }, [
                                              _createVNode(_component_icone, { nome: "estornar" })
                                            ], 8, _hoisted_38))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (column.key === 'TituloFinanceiro')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                          _createElementVNode("span", null, [
                                            _hoisted_40,
                                            _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' + record.descricaoTipoDocumentoFinanceiro), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_41,
                                            _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_42,
                                            _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_43,
                                            _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_44,
                                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorJurosMulta,2)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_45,
                                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorAcrescimo,2)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_46,
                                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorDesconto,2)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_47,
                                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.obterTotalPago(record),2)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_48,
                                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTaxa,2)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_49,
                                            _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _createElementVNode("div", _hoisted_50, [
                                              _createElementVNode("a", {
                                                onClick: ($event: any) => (_ctx.visualizarTituloBaixado(record)),
                                                title: "Visualizar Título"
                                              }, [
                                                _createVNode(_component_icone, { nome: "visualizar" })
                                              ], 8, _hoisted_51)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                        ]),
                        emptyText: _withCtx(() => [
                          (_ctx.state.titulosBaixados.length <= 0)
                            ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                key: 0,
                                mensagem: "Nenhum título encontrado"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "scroll", "row-selection"])
                    ]),
                    _: 1
                  }, 8, ["spinning"]),
                  ((_ctx.state.estornoParcialDisponivel && _ctx.state.codigosTitulosFinanceirosEstorno.length > 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          ((_ctx.state.codigosTitulosFinanceirosEstorno.length === _ctx.state.titulosBaixados.length))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "ant-btn ant-btn-primary ss-btn-tela ant-btn-block",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmarBaixa()))
                              }, " Estornar selecionado(s) "))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "ant-btn ant-btn-primary ss-btn-tela ant-btn-block",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirmarEstornoTitulosSelecionados()))
                              }, " Estornar selecionado(s) "))
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "ant-btn ant-btn-block",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.codigosTitulosFinanceirosEstorno = []))
                          }, " Desmarcar todos ")
                        ]),
                        _hoisted_55
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.state.titulosLancados.length > 0)
                ? (_openBlock(), _createBlock(_component_card, {
                    key: 2,
                    titulo: "TÍTULOS LANÇADOS"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.state.colunasLancados.filter(item => item.visible),
                        "data-source": _ctx.state.titulosLancados,
                        pagination: false,
                        loading: _ctx.state.carregandoTitulosLancados,
                        scroll: _ctx.storeSistema.state.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth), y: 500 },
                        size: "small"
                      }, {
                        bodyCell: _withCtx(({ column, record, text }) => [
                          (column.key === 'TipoDocumentoFinanceiro')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                title: record.descricaoTipoDocumentoFinanceiro
                              }, _toDisplayString(record.siglaTipoDocumentoFinanceiro), 9, _hoisted_56))
                            : (column.key === 'Tipo')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.obterDescricaoTipoTituloFinanceiro(record.tipo)), 1))
                              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text,2)), 1))
                                  : (column.key === 'Acoes')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                        _createElementVNode("a", {
                                          onClick: ($event: any) => (_ctx.visualizarTituloLancado(record)),
                                          title: "Visualizar Título"
                                        }, [
                                          _createVNode(_component_icone, { nome: "visualizar" })
                                        ], 8, _hoisted_61)
                                      ]))
                                    : (column.key === 'Titulo')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                          _createElementVNode("span", null, [
                                            _hoisted_63,
                                            _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_64,
                                            _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_65,
                                            _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_66,
                                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal,2)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_67,
                                            _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _createElementVNode("div", _hoisted_68, [
                                              _createElementVNode("a", {
                                                onClick: ($event: any) => (_ctx.visualizarTituloLancado(record)),
                                                title: "Visualizar Título"
                                              }, [
                                                _createVNode(_component_icone, { nome: "visualizar" })
                                              ], 8, _hoisted_69)
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                        ]),
                        emptyText: _withCtx(() => [
                          (_ctx.state.titulosLancados.length <= 0)
                            ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                key: 0,
                                mensagem: "Nenhum título foi adicionado"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "loading", "scroll"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_card, { titulo: "MOVIMENTOS NAS CONTAS" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: _ctx.state.colunasMovimentos.filter(item => item.visible),
                    "data-source": _ctx.state.movimentosLancados,
                    scroll: _ctx.storeSistema.state.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth), y: 500 },
                    size: "small",
                    pagination: false
                  }, {
                    bodyCell: _withCtx(({ column, record }) => [
                      (column.key === 'Conta')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(record.descricaoConta), 1))
                        : (column.key === 'DataMovimento')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataMovimento)), 1))
                          : (column.key === 'DescricaoTipoMovimento')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(_ctx.obterDescricaoTipoMovimento(record.tipoMovimento)), 1))
                            : (column.key === 'IdentificadorMovimento')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(record.identificadorMovimento), 1))
                              : (column.key === 'CategoriaMovimento')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(record.nomePlanoContaCategoria), 1))
                                : (column.key === 'ValorMovimento')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valor,2)), 1))
                                  : (column.key === 'InfluenciaSaldo')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.obterDescricaoInfluenciaSaldo(record.influenciaSaldo)), 1))
                                    : (column.key === 'Acoes')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                          _createElementVNode("a", {
                                            onClick: ($event: any) => (_ctx.visualizarMovimento(record)),
                                            title: "Visualizar Movimento"
                                          }, [
                                            _createVNode(_component_icone, { nome: "visualizar" })
                                          ], 8, _hoisted_78)
                                        ]))
                                      : (column.key === 'MovimentoBaixa')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                            _createElementVNode("span", null, [
                                              _hoisted_80,
                                              _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_81,
                                              _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataMovimento)), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_82,
                                              _createTextVNode(" " + _toDisplayString(_ctx.obterDescricaoTipoMovimento(record.tipoMovimento)), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_83,
                                              _createTextVNode(" " + _toDisplayString(record.identificadorMovimento), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_84,
                                              _createTextVNode(" " + _toDisplayString(record.nomePlanoContaCategoria), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_85,
                                              _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valor,2)), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _hoisted_86,
                                              _createTextVNode(" " + _toDisplayString(_ctx.obterDescricaoInfluenciaSaldo(record.influenciaSaldo)), 1)
                                            ]),
                                            _createElementVNode("span", null, [
                                              _createElementVNode("div", _hoisted_87, [
                                                _createElementVNode("a", {
                                                  onClick: ($event: any) => (_ctx.visualizarMovimento(record)),
                                                  title: "Visualizar Movimento"
                                                }, [
                                                  _createVNode(_component_icone, { nome: "visualizar" })
                                                ], 8, _hoisted_88)
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                    ]),
                    emptyText: _withCtx(() => [
                      (_ctx.state.movimentosLancados.length <= 0)
                        ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                            key: 0,
                            mensagem: "Nenhum lançamento adicionado ainda"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "scroll"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_conta_receber_modal, {
        operacao: _ctx.state.operacaoLancamento,
        editavel: false,
        visivel: _ctx.state.exibirContaReceber,
        "onUpdate:visivel": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.exibirContaReceber) = $event))
      }, null, 8, ["operacao", "visivel"]),
      _createVNode(_component_conta_pagar_modal, {
        operacao: _ctx.state.operacaoLancamento,
        editavel: false,
        visivel: _ctx.state.exibirContaPagar,
        "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.exibirContaPagar) = $event))
      }, null, 8, ["operacao", "visivel"]),
      _createVNode(_component_movimento_financeiro_modal, {
        operacao: _ctx.state.operacaoLancamento,
        conta: _ctx.state.contaSelecionada,
        visivel: _ctx.state.exibirMovimentoFinanceiro,
        "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.exibirMovimentoFinanceiro) = $event))
      }, null, 8, ["operacao", "conta", "visivel"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}